import { Toast as ToastType } from '../hooks/useToast';

interface Props {
  toasts: ToastType[];
  dismiss: (id: number) => void;
}

const icons = { success: '✓', error: '✕', info: 'ℹ' };

export default function ToastStack({ toasts, dismiss }: Props) {
  if (!toasts.length) return null;
  return (
    <div className="toast-stack">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast-${t.variant}`}
          onClick={() => dismiss(t.id)}
        >
          <span>{icons[t.variant]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
